import { css } from "@emotion/react";

import { textPrimary } from "./typography";

/**
 * Shared styles for Rating cells on Chats & Tickets Satisfaction
 */
export const ratedCount = [
  textPrimary,
  css`
    margin-left: 6px;
    margin-right: 6px;
  `,
];
